/**
 * Created by mykurisu on 2018/4/10.
 */
import React from 'react'
import '../../css/wkCommon.css'


class WKSearchBar extends React.Component {

    static defaultProps = {
        defaultValue: '',
        placeholder: '请输入内容',
        onChange: null,
        onSubmit: null,
        onClear: null,
        onCancel: null,
        autoFocus: false
    };

    constructor(props) {
        super(props)
        this.state = {
            isFocusing: false,
            value: '',
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.defaultValue !== nextProps.defaultValue) {
            this.setState({
                value: nextProps.defaultValue
            })
        }
    }

    componentWillUnmount() {
        this.blud && clearTimeout(this.blud)
    }

    handleFoucs(type) {
        if (type === 'focus') {
            this.setState({
                isFocusing: true
            })
        } else {
            this.blud = setTimeout(() => {
                this.setState({
                    isFocusing: false
                })
            }, 500)
        }
    }

    handleChange(e) {
        this.setState({
            value: e.target.value
        }, () => {
            this.props.onChange && this.props.onChange(this.state.value)
        })
    }

    handleSubmit(e) {
        if (!this.props.onSubmit) {
            return
        }
        e.preventDefault();
        e.stopPropagation();
        this.props.onSubmit(this.state.value, e)
    }

    handleClear() {
        this.setState({
            value: ''
        }, () => {
            this.props.onClear && this.props.onClear()
        })
    }

    render() {
        const {isFocusing, value} = this.state
        const defaultType = !isFocusing && !value

        return (
            <div className="wk__searchbar">
                <form action="" onSubmit={(e) => this.handleSubmit(e)}>
                    <div className="searchbar__content">
                        {(isFocusing || value !== '') &&
                        <div className="content__icon">
                            <img
                                src="https://static-1253442168.image.myqcloud.com/picture/5459246_89651b7fe3782205fa11eb518b9266bc.jpg"
                                alt="icon"/>
                        </div>
                        }
                        {defaultType &&
                        <div className="content__text">
                            <div className="text__icon">
                                <img
                                    src="https://static-1253442168.image.myqcloud.com/picture/5459246_89651b7fe3782205fa11eb518b9266bc.jpg"
                                    alt="icon"/>
                            </div>
                            <span>搜索</span>
                        </div>
                        }
                        <input
                            autoFocus={this.props.autoFocus}
                            onBlur={() => this.handleFoucs('blur')}
                            onFocus={() => this.handleFoucs('focus')}
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.value}
                            className="content__input" placeholder={isFocusing ? this.props.placeholder : ''}
                            type="search"
                        />
                    </div>
                </form>
                {isFocusing && value !== '' &&
                <div className="searchbar__btn" onClick={(e) => this.handleSubmit(e)}>
                    搜索
                </div>
                }
            </div>
        )
    }
}

export default WKSearchBar



// WEBPACK FOOTER //
// ./src/components/wk/WKSearchBar.js